module.exports = __webpack_public_path__ + "static/media/edit_white.9e2525aa.svg";